export default theme => ({
  hexaSvg8: {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    right: -200,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hexaSvg9: {
    zIndex: 2,
    position: 'absolute',
    top: 'calc(50% + 20px)',
    right: -30,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  container: {
    backgroundColor: theme.palette.common.white,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    overflow: 'hidden',
  },
  titleContainer: {
    paddingBottom: theme.spacing(8),
  },
  title: {
    color: theme.palette.blue.light,
    textAlign: 'center',
  },
  ficheGrid: {
    paddingBottom: theme.spacing(2),
  },
  ficheContainer: {
    marginBottom: theme.spacing(3),
  },
  ficheNum: {
    fontWeight: 300,
  },
  ficheCat: {
    fontWeight: 400,
    color: theme.palette.blue.light,
    textTransform: 'uppercase',
  },
  ficheTitle: {
    marginBottom: theme.spacing(1),
    '& i': {
      fontWeight: 400,
      fontStyle: 'normal',
    },
  },
});
